"use client";

import { Wrapper } from "./components/wrapper";
import { LayoutProvider } from "./components/context";
import { useTranslations } from "next-intl";

export function Layout30({ children }: { children: React.ReactNode }) {
  const t = useTranslations("layout30");

  return (
    <LayoutProvider
      style={
        {
          "--header-height": "60px",
          "--sidebar-width": "60px",
          "--sidebar-menu-width": "240px",
        } as React.CSSProperties
      }
    >
      <button
        type="button"
        onClick={() => document.getElementById("workspace-content")?.focus()}
        className="sr-only z-50 rounded-md bg-background px-3 py-2 text-sm font-medium text-foreground shadow-md focus:not-sr-only focus:fixed focus:start-3 focus:top-3"
      >
        {t("skipToContent")}
      </button>
      <Wrapper>{children}</Wrapper>
    </LayoutProvider>
  );
}
